import styled from "@emotion/styled";

const InspectorElementsWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export default InspectorElementsWrapper;